<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="isScreenAccessible else screenNotAccessible" style="overflow: auto;">
    <app-my-skill-acknowledgements-list #skillAckPanel 
    [showLoader] = "showLoader" 
    [skillAcknowledgements]=skillAcknowledgements
    [isShowCheckbox]=displayShowAllButton 
    [enableInactiveLabel]=displayShowAllLabel 
    (checkboxSelection)="getSkillListData($event)" 
    [showInformationIconCheckbox]=showInformationIconCheckbox 
    [informationIconTooltip]="showAllToolTip" 
    [checkboxLabel]="showAllLabel"
    (reloadMySkillAcknowledgements)="getSkillListData($event,true)">
    </app-my-skill-acknowledgements-list>
</div>
<ng-template #screenNotAccessible>
    <app-error [errorMessage]="errorMessage"></app-error>
  </ng-template>